/* ============================================================
   CLARITY · Produktbilder auf den Laborkarten
   Angelegt 29.08.2026.

   WARUM: Die Karten der Laborseite zeigten oben ein 48-px-Dokument-
   symbol in einer 366 x 458 px grossen Flaeche - rund 61 % der Karte
   standen leer. Marcus: "damit dieses Feld nicht so leer aussieht"
   und "damit die Leute direkt schnell wissen, um welches Produkt es
   sich handelt".

   WIE: Das Bild wird aus den Produktdaten des Shops gezogen (Vorgabe
   Marcus), nicht neu gepflegt. Zuordnung ueber die Ueberschrift der
   Karte. Additiv per Skript, damit die 26 KB grosse Sektionsdatei
   clarity-lab.liquid unberuehrt bleibt.

   Zwei Karten bekommen bewusst kein Produktbild:
     VERISOL® B         ist ein Markenrohstoff, kein Produkt -> Herstellerzeichen
     Pestizid-Screening hat noch keinen Bericht -> bleibt beim Symbol,
                        die Leere ist dort inhaltlich richtig

   RUECKBAU: die zwei Zeilen in snippets/clarity-ci-css.liquid entfernen.
   ============================================================ */

(function () {
  'use strict';

  // Aus den Produktdaten des Shops, Stand 29.08.2026.
  var BILDER = {
    'pure collagen':      'files/Pur_Beutel_d5a00dad-5872-4e27-9fc4-f7fc0901fe77',
    'matcha collagen':    'files/Matcha_Beutel_0bb476ba-c207-41d8-aad1-c140046ad3ee',
    'beauty stake':       'files/ChatGPT_Image_24._Aug._2026_18_02_25',
    'collagen complex':   'files/Collagen_Complex_Final',
    'keto creamer':       'files/1_f83ba9ba-836b-4c56-a6b1-38423491013a',
    'liquid rootshot':    'files/1_668f2c6c-f569-46e9-9aa3-60641eaeafb3'
  };
  var ENDUNG = {
    'files/1_f83ba9ba-836b-4c56-a6b1-38423491013a': 'jpg',
    'files/1_668f2c6c-f569-46e9-9aa3-60641eaeafb3': 'jpg'
  };
  var BASIS = 'https://cdn.shopify.com/s/files/1/0880/4188/1947/';

  /* Markenrohstoffe: die Herstellerzeichen liegen im Theme.
     Drei Rohstoffe, ZWEI Hersteller - SOLUGEL ist PB Leiner,
     VERISOL und FORTIGEL sind GELITA. Nicht zusammenwerfen. */
  var MARKEN = [
    { treffer: /verisol/i,  datei: 'clarity-trust-verisol.png'  },
    { treffer: /fortigel/i, datei: 'clarity-trust-fortigel.png' },
    { treffer: /solugel/i,  datei: 'clarity-trust-solugel.png'  }
  ];
  function markenBild(titel) {
    for (var i = 0; i < MARKEN.length; i++) {
      if (MARKEN[i].treffer.test(titel)) return MARKEN[i].datei;
    }
    return null;
  }

  function bildFuer(titel) {
    var t = titel.toLowerCase()
      .replace(/[®™]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
    for (var k in BILDER) {
      if (t.indexOf(k) === 0 || t === k) {
        var pfad = BILDER[k];
        return BASIS + pfad + '_400x.' + (ENDUNG[pfad] || 'png');
      }
    }
    if (markenBild(t)) return null;   // Markenrohstoffe: gesondert behandelt
    return null;
  }

  function aufbauen() {
    var karten = document.querySelectorAll('.doc-in');
    if (!karten.length) return;

    Array.prototype.forEach.call(karten, function (karte) {
      var thumb = karte.querySelector('.thumb');
      var ph = karte.querySelector('.ph');
      var h3 = karte.querySelector('h3');
      if (!thumb || !ph || !h3) return;
      if (thumb.querySelector('.cl-lab-bild')) return;   // schon gesetzt

      var titel = (h3.textContent || '').trim();
      var quelle = bildFuer(titel);
      var markeDatei = markenBild(titel);

      if (!quelle && !markeDatei) return;   // Karten ohne Bild bleiben, wie sie sind

      var img = document.createElement('img');
      img.className = 'cl-lab-bild';
      img.alt = '';                     // rein schmueckend, der Titel steht daneben
      img.setAttribute('aria-hidden', 'true');
      img.loading = 'lazy';
      img.decoding = 'async';

      if (markeDatei) {
        /* Der Asset-Pfad enthaelt eine Theme-Nummer (…/t/50/assets/…),
           die sich bei jedem Theme aendert. Auf der Laborseite gibt es
           kein clarity-trust-Bild, aus dem sie sich ableiten liesse -
           der erste Versuch lief deshalb ins Leere. Verlaesslich ist
           jede geladene Theme-CSS: gleicher Ordner, gleicher Pfad. */
        var ref = document.querySelector('link[href*="/assets/clarity-"]');
        if (!ref) return;
        img.src = ref.href.split('?')[0].replace(/\/assets\/[^/]+$/, '/assets/' + markeDatei);
        img.className += ' cl-lab-bild--marke';
      } else {
        img.src = quelle;
      }

      // Vor den Platzhalter setzen, das Symbol wird per CSS ausgeblendet
      thumb.insertBefore(img, ph);
      thumb.classList.add('hat-bild');

      // Pruefnorm als ruhige Meta-Zeile darunter
      if (!thumb.querySelector('.cl-lab-norm') && !markeDatei) {
        var norm = document.createElement('span');
        norm.className = 'cl-lab-norm';
        norm.textContent = 'ISO/IEC 17025 · GBA Group';
        ph.appendChild(norm);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', aufbauen);
  } else {
    aufbauen();
  }
})();
